import React from 'react';
import './CTA.css';

const CTA = () => {
  return (
    <section id="contact" className="cta">
      <div className="container">
        <div className="cta-content">
          <div className="cta-text">
            <h2>Ready to Optimize Your AWS Costs?</h2>
            <p>
              Join hundreds of companies already saving money with Finoptic. 
              Start your free trial today and see results within 24 hours.
            </p>
            <ul className="cta-features">
              <li>✅ 14-day free trial</li>
              <li>✅ No credit card required</li>
              <li>✅ Setup in under 5 minutes</li>
              <li>✅ Cancel anytime</li>
            </ul>
          </div>
          
          <div className="cta-form">
            <div className="form-container">
              <h3>Start Your Free Trial</h3>
              <form className="trial-form">
                <input 
                  type="text" 
                  placeholder="Company Name" 
                  required 
                />
                <input 
                  type="email" 
                  placeholder="Work Email" 
                  required 
                />
                <input 
                  type="text" 
                  placeholder="AWS Account ID (Optional)" 
                />
                <select required>
                  <option value="">Monthly AWS Spend</option>
                  <option value="0-1k">$0 - $1,000</option>
                  <option value="1k-10k">$1,000 - $10,000</option>
                  <option value="10k-50k">$10,000 - $50,000</option>
                  <option value="50k+">$50,000+</option>
                </select>
                <button type="submit" className="btn btn-primary btn-full">
                  Start Free Trial
                </button>
              </form>
              <p className="form-note">
                By signing up, you agree to our Terms of Service and Privacy Policy
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;